import React from 'react'

interface RiskScoreBadgeProps {
  score: number
  showLabel?: boolean
}

const RiskScoreBadge: React.FC<RiskScoreBadgeProps> = ({ score, showLabel = true }) => {
  const getRiskLevel = (score: number): { label: string; color: string; bgColor: string } => {
    if (score >= 90) {
      return { label: 'Critical', color: 'text-risk-critical', bgColor: 'bg-risk-critical/10' }
    } else if (score >= 70) {
      return { label: 'High', color: 'text-risk-high', bgColor: 'bg-risk-high/10' }
    } else if (score >= 40) {
      return { label: 'Medium', color: 'text-risk-medium', bgColor: 'bg-risk-medium/10' }
    } else {
      return { label: 'Clean', color: 'text-risk-clean', bgColor: 'bg-risk-clean/10' }
    }
  }

  const risk = getRiskLevel(score)

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full ${risk.bgColor}`}>
      <span className={`text-sm font-semibold ${risk.color}`}>{score}</span>
      {showLabel && <span className={`text-xs font-medium ${risk.color}`}>{risk.label}</span>}
    </div>
  )
}

export default RiskScoreBadge
